
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Punetosatarakaspatharcab() {



    const cardData =
    {
        keyword: 'Pune to Satara Kas Pathar Cab Services',
        heading: 'S9 Travels: Pune to Satara Kas Pathar Cab Services',
        headingDescription: 'S9 Travels offers comfortable, reliable, and affordable cab services from Pune to Satara Kas Pathar. Known for its natural beauty, Kas Pathar is often referred to as the "Valley of Flowers" and is a popular destination for nature lovers, photographers, and those seeking a peaceful escape. Located approximately 140 km from Pune, the journey takes around 3 to 4 hours by road. With S9 Travels, enjoy a smooth and hassle-free ride with top-notch amenities and professional drivers ensuring a safe and enjoyable journey.',

        top: 'Top Places to Visit in Satara Kas Pathar with S9 Travels',

"topPlaces": [
    {
      "title": "Kas Pathar (Kas Plateau)",
      "description": "Kas Pathar is the star attraction of Satara, known for its stunning landscape and vibrant wildflowers. The plateau comes alive during the monsoon season with a blanket of colorful blooms, making it a perfect spot for nature lovers, photographers, and trekkers."
    },
    {
      "title": "Kas Lake",
      "description": "Kas Lake, located near Kas Pathar, is a beautiful and serene spot, ideal for a peaceful retreat. Surrounded by hills and lush greenery, the lake is perfect for a quiet day by the water, picnicking, or enjoying the natural beauty of the area."
    },
    {
      "title": "Ajinkyatara Fort",
      "description": "Ajinkyatara Fort is located atop a hill near Satara and offers panoramic views of the surrounding landscape, including Kas Plateau. The fort is historically significant and provides a bit of a trek for adventure enthusiasts, with breathtaking views at the top."
    },
    {
      "title": "Sajjangad Fort",
      "description": "Sajjangad Fort, located about 20 km from Satara, is an important religious site. The fort is dedicated to the saint Samarth Ramdas, a mentor to Chhatrapati Shivaji Maharaj. The peaceful surroundings and spiritual significance make it a must-visit place near Kas Pathar."
    },
    {
      "title": "Thoseghar Waterfall",
      "description": "Thoseghar Waterfall is a stunning waterfall located around 20 km from Satara, offering breathtaking views, especially during the monsoon season. The fall is surrounded by greenery and is a popular spot for picnics and nature walks."
    },
    {
      "title": "Koyna Dam",
      "description": "Koyna Dam, situated near Satara, is a large reservoir that offers picturesque views of the dam surrounded by hills. The area around the dam is perfect for nature walks, photography, and enjoying the calm, scenic surroundings."
    },
    {
      "title": "Lingmala Waterfall",
      "description": "Lingmala Waterfall, located near Mahabaleshwar (about 60 km from Satara), is a beautiful spot to visit when you're in the area. It’s known for its picturesque surroundings and is especially stunning during the monsoon when the waterfall is in full flow."
    },
    {
      "title": "Panchgani",
      "description": "Panchgani, located around 45 km from Satara, is a popular hill station known for its pleasant climate and scenic views. The place offers a variety of viewpoints, including the famous Table Land, and is ideal for a relaxing getaway amidst nature."
    },
    {
      "title": "Bhivpuri Waterfalls",
      "description": "Bhivpuri Waterfalls, located near Satara, is a beautiful spot for nature lovers and trekkers. The waterfall is surrounded by lush greenery and is a great place for a picnic, photography, or a short trek."
    }
],

"services": [
    {
      "name": "Book Pune to Satara Kas Pathar Taxi",
      "description": "S9 Travels offers comfortable and reliable taxi services from Pune to Satara Kas Pathar, one of the most scenic spots in Maharashtra. Whether you're a nature lover or a photographer looking to capture the beauty of the famous Kas Plateau, our services ensure a smooth journey with breathtaking views along the way. With professional drivers and well-maintained vehicles, your trip to Kas Pathar will be a memorable experience."
    },
    {
      "name": "Book Pune to Satara Kas Pathar Cab Service",
      "description": "Enjoy a seamless ride with S9 Travels' cab services from Pune to Satara Kas Pathar. Our fleet includes various vehicles, from compact cars to SUVs, ensuring that we can cater to your comfort and group size. Whether you're visiting the area for a day trip or planning a weekend escape, we guarantee punctuality, comfort, and a hassle-free journey."
    },
    {
      "name": "Pune to Satara Kas Pathar One-Way Taxi",
      "description": "Planning a quick one-way trip to Kas Pathar? S9 Travels offers an affordable one-way taxi service from Pune to Satara Kas Pathar, giving you the freedom to travel without the stress of planning a round-trip. Our one-way service is designed to be convenient, with a direct route to Kas Pathar, so you can enjoy the stunning views without worrying about the return."
    },
    {
      "name": "Pune to Satara Kas Pathar Round Trip",
      "description": "If you want to enjoy both the journey and the destination, S9 Travels' round-trip taxi service is the perfect choice for you. We ensure a comfortable round trip from Pune to Satara Kas Pathar, with a flexible schedule. Our professional drivers will wait for you as you explore the beauty of Kas Plateau, famous for its seasonal flower blooms, rare flora, and scenic views. After a relaxed visit, your driver will take you back to Pune in comfort."
    },
    {
      "name": "Pune to Satara Kas Pathar Taxi Fare",
      "description": "S9 Travels offers transparent and affordable taxi fares for your journey to Satara Kas Pathar. With no hidden charges, you can plan your trip confidently. Whether you're traveling alone, with a partner, or in a group, we ensure that our taxi fares remain competitive and budget-friendly while providing the best service."
    },
    {
      "name": "Pune to Satara Kas Pathar Car Rental",
      "description": "For a more personalized travel experience, S9 Travels offers car rental services from Pune to Satara Kas Pathar. Choose from a wide range of vehicles, including sedans, SUVs, and luxury cars, to make your trip comfortable and convenient. Our cars are well-maintained, and our drivers are experienced, ensuring that your journey is smooth and enjoyable."
    },
    {
      "name": "Pune to Satara Kas Pathar Luxury Taxi",
      "description": "Indulge in luxury and comfort with S9 Travels' luxury taxi services for your trip to Satara Kas Pathar. Our fleet includes premium cars that offer extra space, comfort, and luxury features. Whether you're celebrating a special occasion or simply want to enjoy a lavish experience, our luxury taxis provide the perfect way to travel in style."
    },
    {
      "name": "Pune to Satara Kas Pathar Efficient Taxi",
      "description": "If you're looking for a more economical option, S9 Travels offers Efficient Taxi services from Pune to Satara Kas Pathar. Share the ride with other travelers and enjoy a comfortable journey at a reduced fare. This option is perfect for solo travelers or small groups who want to experience the beauty of Kas Pathar without the cost of a private ride."
    },
    {
      "name": "Satara Kas Pathar Cab from Pune",
      "description": "Traveling to Satara Kas Pathar from Pune is easy with S9 Travels. We provide reliable and timely cab services, whether you are going for a quick visit or an extended exploration. Our drivers are well-versed in the best routes and will ensure you reach your destination safely and efficiently, so you can focus on enjoying your time in the flower valley."
    },
    {
      "name": "Affordable Satara Kas Pathar Taxi",
      "description": "Looking for an affordable taxi service from Pune to Satara Kas Pathar? S9 Travels offers competitive prices without compromising on comfort or service quality. We strive to make your trip to one of Maharashtra’s most beautiful natural spots as affordable as possible, so you can enjoy the beauty of Kas Pathar without breaking the bank."
    },
    {
      "name": "Pune to Satara Kas Pathar Private Cab",
      "description": "If you prefer a more private and personalized experience, book a private cab with S9 Travels. Our private taxi services from Pune to Satara Kas Pathar give you the flexibility to enjoy your journey at your own pace. Whether you're visiting for a day or planning a weekend trip, our drivers will be at your service for the entire duration of your trip, providing you with a customized experience."
    },
    {
      "name": "Group Tour to Satara Kas Pathar",
      "description": "Traveling with friends or family? S9 Travels offers excellent group travel services to Satara Kas Pathar. Whether you're going for sightseeing, photography, or simply to relax in nature, our vehicles are spacious and can accommodate larger groups comfortably. Our drivers ensure that your group enjoys a smooth and enjoyable journey to Kas Pathar, allowing you to focus on making lasting memories together."
    },
    {
      "name": "Weekend Satara Kas Pathar Trip",
      "description": "Plan a weekend getaway to Satara Kas Pathar with S9 Travels. A short escape to the floral paradise is the perfect way to recharge. Whether you want to take a leisurely stroll among the flowers or capture the vibrant blooms through your lens, we ensure a relaxing ride to and from Pune. Let us handle the logistics while you enjoy a peaceful weekend in nature."
    },
    {
      "name": "Satara Kas Pathar Sightseeing Tour",
      "description": "Take a sightseeing tour of Satara Kas Pathar with S9 Travels. Our drivers know all the best spots for exploring the famous flower valley and can even share insights into the history of the region. From the best photo opportunities to the most scenic walking trails, we’ll guide you through the beauty of Kas Pathar, ensuring you don’t miss a thing."
    }
],

"tableData": [
  ["Book Pune To Satara Kas Pathar Taxi", "Book Pune To Satara Kas Pathar Cab Service"],
  ["Book Pune To Satara Kas Pathar One-Way Taxi", "Book Pune To Satara Kas Pathar Round Trip"],
  ["Book Pune To Satara Kas Pathar Taxi Fare", "Book Pune To Satara Kas Pathar Car Rental"],
  ["Book Pune To Satara Kas Pathar Luxury Taxi", "Book Pune To Satara Kas Pathar Efficient Taxi"],
  ["Satara Kas Pathar Cab from Pune", "Affordable Satara Kas Pathar Taxi"],
  ["Pune to Satara Kas Pathar Private Cab", "Group Tour to Satara Kas Pathar"],
  ["Weekend Satara Kas Pathar Trip", "Satara Kas Pathar Sightseeing Tour"]
],
"whychoose": [
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "At S9 Travels, we understand the importance of a timely visit when traveling to the beautiful Kas Pathar in Satara. Our drivers ensure timely pickups and drop-offs, so you can enjoy the scenic beauty of the flower valley without any delays."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Vehicles",
    "WhyChoosedescription": "We offer a variety of well-maintained vehicles, including sedans, SUVs, and premium cars, for your journey from Pune to Satara Kas Pathar. All our vehicles are equipped with spacious interiors, air conditioning, and ample luggage space, ensuring a comfortable and relaxed ride."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our drivers are experienced and knowledgeable about the best routes to Satara Kas Pathar. They prioritize your safety and comfort, making sure you have a smooth and enjoyable journey while exploring the mesmerizing flower valley and surrounding areas."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers competitive and transparent pricing for your Pune to Satara Kas Pathar trip. There are no hidden charges, and we provide a clear breakdown of costs, so you know exactly what to expect, making your trip cost-effective and worry-free."
  },
  {
    "WhyChooseheading": "Safe and Comfortable Journey",
    "WhyChoosedescription": "Your safety is our priority. All our vehicles are equipped with modern safety features such as airbags, seat belts, and GPS tracking, ensuring a secure and comfortable journey to Satara Kas Pathar."
  },
  {
    "WhyChooseheading": "24/7 Availability",
    "WhyChoosedescription": "Whether you’re planning an early morning trip or a late-night return, S9 Travels is available around the clock to cater to your needs. Our customer service team is always ready to assist you with bookings, inquiries, or any other requirements."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Booking a cab for your Pune to Satara Kas Pathar journey is simple and convenient with S9 Travels. You can easily book through our website or mobile app, or you can contact our customer service team for personalized assistance with your booking."
  },
  {
    "WhyChooseheading": "Customized Travel Packages",
    "WhyChoosedescription": "Whether you are visiting Satara Kas Pathar for its breathtaking views or a nature-filled experience, we offer customized travel packages that suit your preferences. Let us know your requirements, and we’ll ensure the trip is special and memorable."
  }
]




















    }



    const faqData = [
        [
          {
            question: 'How can I book a Pune to Satara Kas Pathar cab with S9 Travels?',
            answer: 'Booking a cab is easy! You can book online through our website or app, or you can contact our customer service team for personalized assistance and help with planning your trip.',
          },
          {
            question: 'What types of vehicles are available for the Pune to Satara Kas Pathar trip?',
            answer: 'We offer a range of vehicles, including sedans, SUVs, and premium cars. All our vehicles are well-maintained and designed for comfort and safety on long trips.',
          },
          {
            question: 'Are the drivers experienced for long-distance travel to Satara Kas Pathar?',
            answer: 'Yes, our drivers are highly experienced in long-distance travel and are familiar with the best routes to Satara Kas Pathar. They ensure a safe and smooth ride, letting you enjoy the beautiful views.',
          },
          {
            question: 'How do I pay for my Pune to Satara Kas Pathar cab rental?',
            answer: 'We offer multiple payment options, including cash, credit/debit cards, and online payments via our app, making it convenient for you to pay for your ride.',
          },
          {
            question: 'Can I book a round-trip from Pune to Satara Kas Pathar?',
            answer: 'Yes, we can arrange a round-trip for you. Simply provide us with your return details, and we’ll ensure a smooth and comfortable return journey from Kas Pathar.',
          },
          {
            question: 'Are there any extra charges for waiting or detours during the trip?',
            answer: 'Any additional charges, such as waiting time or detours, will be communicated to you upfront, ensuring complete transparency in pricing.',
          },
          {
            question: 'Can I hire a cab for sightseeing in Satara Kas Pathar?',
            answer: 'Yes, we offer sightseeing services around Satara Kas Pathar. Explore the stunning flower valley, nearby viewpoints, and other attractions with the help of our experienced drivers.',
          },
          {
            question: 'What is the luggage allowance for a Pune to Satara Kas Pathar cab?',
            answer: 'Our vehicles can comfortably accommodate standard luggage. If you have additional luggage or specific requirements, please inform us during the booking process, and we’ll make the necessary arrangements.',
          },
          {
            question: 'Is S9 Travels available for corporate or group travel to Satara Kas Pathar?',
            answer: 'Yes, we offer corporate and group travel services to Satara Kas Pathar. Whether it’s a corporate outing or a family trip, we ensure a comfortable and enjoyable experience for everyone.',
          },
          {
            question: 'Why should I choose S9 Travels for my Pune to Satara Kas Pathar journey?',
            answer: 'S9 Travels guarantees a reliable, comfortable, and affordable journey with professional drivers, well-maintained vehicles, and excellent customer service. We prioritize your safety and comfort, ensuring a smooth and memorable trip to Satara Kas Pathar.',
          },
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Abhay Joshi',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“I booked a cab with S9 Travels for my trip to Satara Kas Pathar. The ride was comfortable, and the driver was very professional. Kas Pathar was breathtaking, and the journey was smooth. Highly recommend S9 Travels for a hassle-free trip!”',
        },
        {
          name: 'Mrs. Meera Deshmukh',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“Our visit to Satara Kas Pathar was wonderful, thanks to S9 Travels. The vehicle was spacious and clean, and the driver was friendly and knowledgeable about the area. We had an amazing time exploring the flower valley!”',
        },
      ];
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   
    const productSchema = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Pune To Satara Kas Pathar Cab Service",
        "description": "Book Pune to Satara Kas Pathar cab services with S9 Travels. Whether you need a one-way taxi, round-trip, luxury taxi, or car rental, we offer affordable and reliable transport to Kas Pathar in Satara. Plan a private cab trip, group tour, or a sightseeing journey to the famous Kas Pathar Plateau for a beautiful getaway from Pune.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.8",
          "ratingCount": "8569"
        }
      };
      
     
      
      


    return (
        <div>
          <Helmet>
        <title>Pune To Satara Kas Pathar Cab Service | Affordable Taxi & Car Rentals | S9 Travels | Contact: +91 8850328441</title>
        <meta 
          name="description" 
          content="Book Pune to Satara Kas Pathar taxi services, one-way, round-trip, luxury taxis, Efficient Taxis, and car rentals with S9 Travels. Get the best fares for your Kas Pathar sightseeing tour, private cab bookings, group tours, and weekend trips to Satara from Pune." 
        />
        
        {/* Inject JSON-LD Schema */}
        <script type="application/ld+json">
          {JSON.stringify(productSchema)}
        </script>
      </Helmet>
      
<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/25.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetosatarakaspatharcab;